import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
} from '@mui/material';
import { useField } from 'formik';

export interface FormikSelectFieldProps {
  name: string;
  label: string;
  required?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  onActive?: (active: boolean) => void;
  sx?: SxProps;
  options: {
    id: string;
    displayName: string;
    hidden?: boolean;
    disabled?: boolean;
  }[];
  testId?: string;
}

export const FormikSelectField = (props: FormikSelectFieldProps) => {
  const [field, meta] = useField(props.name);
  const hasError = meta.touched && Boolean(meta.error);
  return (
    <FormControl>
      <InputLabel id={`select-${props.label}`}>{props.label}</InputLabel>
      <Select
        id={props.name}
        labelId={`select-${props.label}`}
        name={props.name}
        label={props.label}
        required={props.required}
        fullWidth={props.fullWidth ?? true}
        value={field.value}
        onChange={field.onChange}
        onBlur={(e) => {
          field.onBlur(e);
          if (props.onActive) props?.onActive(false);
        }}
        onFocus={() => {
          if (props.onActive) props.onActive(true);
        }}
        error={hasError}
        disabled={props.disabled}
        autoComplete={props.autoComplete ?? 'off'}
        sx={props.sx}
        inputProps={{
          'data-testid': props.testId,
        }}
      >
        {props.options
          ?.filter((option) => !option.hidden)
          .map((option) => (
            <MenuItem
              id={`option-${option.id}`}
              key={option.id}
              value={option.id}
              disabled={option.disabled}
            >
              {option.displayName}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
